module.exports = __webpack_public_path__ + "img/coins-swap-01.ba348b49.svg";